export default __webpack_public_path__ + "static/media/cricket_icon.01085e92.png";